export default "__VITE_ASSET__BMNW5SyG__"